import { DumpYardTemplate } from '../../../models';
import { DumpYardTemplateForm } from '../TriplePInterface';

export interface DumpYardTemplatePayload {
  data: {
    type: string;
    attributes: {
      address: string;
      zip: string;
      name?: string;
      is_dump_yard?: boolean;
      is_storage?: boolean;
      is_quick_stop?: boolean;
      is_active?: boolean;
      price_per_ton?: number;
      min_dump_weight?: number;
      service_time_override?: number;
      operating_hours_start?: number;
      operating_hours_end?: number;
      waste_types?: string;
    }
  }
}

export const toDumpYardTemplate = (form: DumpYardTemplateForm): DumpYardTemplatePayload => {
  const isFacility = form.isDumpYard || form.isStorage;
  return {
    data: {
      type: 'dump_yard_templates',
      attributes: {
        address: form.address,
        zip: form.zip,
        name: form.name,
        is_dump_yard: form.isDumpYard,
        is_storage: form.isStorage,
        is_quick_stop: form.isQuickStop,
        is_active: form.isActive,
        ...(form.isDumpYard && form.pricePerTon != null
          ? { price_per_ton: form.pricePerTon }
          : {}),
        ...(form.isDumpYard && form.minDumpWeight != null
          ? { min_dump_weight: form.minDumpWeight }
          : {}),
        ...(form.isDumpYard && form.serviceTimeOverride != null
          ? { service_time_override: form.serviceTimeOverride }
          : {}),
        ...(isFacility && form.operatingHoursStart != null
          ? { operating_hours_start: form.operatingHoursStart }
          : {}),
        ...(isFacility && form.operatingHoursEnd != null
          ? { operating_hours_end: form.operatingHoursEnd }
          : {}),
        ...(form.isDumpYard && form.wasteTypes.length > 0
          ? { waste_types: form.wasteTypes.join(',') }
          : {}),
      }
    }
  };
}

export interface UpdateDumpYardTemplatePayload {
  data: {
    id: string;
    type: string;
    attributes: {
      address: string;
      zip: string;
      name?: string;
      latitude: number;
      longitute: number;
      is_dump_yard?: boolean;
      is_storage?: boolean;
      is_quick_stop?: boolean;
      is_active?: boolean;
      price_per_ton?: number;
      min_dump_weight?: number;
      service_time_override?: number;
      operating_hours_start?: number;
      operating_hours_end?: number;
      waste_types?: string;
    }
  }
}

export const toUpdateDumpYardTemplate = (template: DumpYardTemplate): UpdateDumpYardTemplatePayload => {
  const isFacility = template.isDumpYard || template.isStorage;
  return {
    data: {
      id: template.id,
      type: 'dump_yard_templates',
      attributes: {
        address: template.address,
        zip: template.zip,
        name: template.name,
        latitude: template.latitude,
        longitute: template.longitude,
        is_dump_yard: template.isDumpYard,
        is_storage: template.isStorage,
        is_quick_stop: template.isQuickStop,
        is_active: template.isActive,
        ...(template.isDumpYard && template.pricePerTon != null
          ? { price_per_ton: template.pricePerTon }
          : {}),
        ...(template.isDumpYard && template.minDumpWeight != null
          ? { min_dump_weight: template.minDumpWeight }
          : {}),
        ...(template.isDumpYard && template.serviceTimeOverride != null
          ? { service_time_override: template.serviceTimeOverride }
          : {}),
        ...(isFacility && template.operatingHoursStart != null
          ? { operating_hours_start: template.operatingHoursStart }
          : {}),
        ...(isFacility && template.operatingHoursEnd != null
          ? { operating_hours_end: template.operatingHoursEnd }
          : {}),
        ...(template.isDumpYard && template.wasteTypes.length > 0
          ? { waste_types: template.wasteTypes.join(',') }
          : {}),
      }
    }
  };
}
